// 全局过滤器
/*      
function trim(str)                      删除左边空格 
function parseTime(str,cFormat)         时间格式化
function formatNuber(val)               保留小数2位
function formatMoney(val)               格式货币
*/
export function trim(str) {
  return str.replace(/(^\s*)|(\s*$)/g, "");
}

export function parseTime(time, cFormat) {
  if (arguments.length === 0 || !time) {
    return null;
  }
  const format = cFormat || "{y}-{m}-{d} {h}:{i}:{s}";
  let date;
  if (typeof time === "object") {
    date = time;
  } else {
    if (("" + time).length === 10) time = parseInt(time) * 1000;
    date = new Date(time);
  }
  const formatObj = {
    y: date.getFullYear(),
    m: date.getMonth() + 1,
    d: date.getDate(),
    h: date.getHours(),
    i: date.getMinutes(),
    s: date.getSeconds(),
    a: date.getDay(),
  };
  const time_str = format.replace(/{(y|m|d|h|i|s|a)+}/g, (result, key) => {
    let value = formatObj[key];
    if (key === "a")
      return ["一", "二", "三", "四", "五", "六", "日"][value - 1];
    if (result.length > 0 && value < 10) {
      value = "0" + value;
    }
    return value || 0;
  });
  return time_str;
}

export function formatNuber(val) {
  let valNumber = Number(val);
  return valNumber == 0 ? "0.00" : valNumber.toFixed(2);
}

export function formatMoney(s, n) {
  if (s) {
    n = n > 0 && n <= 20 ? n : 2;
    s = parseFloat((s + "").replace(/[^\d\.-]/g, "")).toFixed(n) + "";
    let l = s
      .split(".")[0]
      .split("")
      .reverse();
    let r = s.split(".")[1];
    let t = "";
    let len = l.length;
    for (let i = 0; i < len; i++) {
      t += l[i] + ((i + 1) % 3 == 0 && i + 1 != l.length ? "," : "");
    }
    return (
      t
        .split("")
        .reverse()
        .join("") +
      "." +
      r
    );
  } else {
    return "0.00";
  }
}



